/*
 * @Descripttion: 
 * @Date: 2021-07-02 15:25:06
 * @LastEditors: Lj07
 * @LastEditTime: 2021-08-12 15:11:41
 */
import { post } from "../axios";
import router from "../../router/index";

const getAppid = url => {
  console.log(location.href);
  // url = location.href
  const fid = sessionStorage.getItem("fid");
  post("app/login/getAppid",{ fid:fid }).then(res => {
    url = encodeURIComponent(url);
    const appid = res.appid;
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
  });
};

const login = code => {
  return new Promise((resolve, reject) => {
    const fid = sessionStorage.getItem("fid");
    post("app/login/wxlogin", { code,fid }).then(res => {
      console.log(res);
      switch (res.type) {
        // 登录成功 // openid 有 
        case 1:
          sessionStorage.setItem("token", res.token);
          resolve(1);
          break;
        // 跳登录 openid 没 
        case 2:
          const data = JSON.stringify(res);
          sessionStorage.setItem("bindInfo", data);
          router.push({ path: "/enter" });
          resolve(2);
          break;
      }
    })
    .catch((error) => {
      //  router.push({ path: "/bandinfo" });
      router.push({ path: "/enter" });
    });
  });
};

export default {
  getAppid,
  login
};



// WEBPACK FOOTER //
// ./src/Interface/api/login.js